import Vue from 'vue'

import { mapState } from 'vuex'
export default {
    computed: {
        ...mapState(['projectData', 'playItem'])
    },
    data: () => ({
        projectId: ''
    }),
    methods: {
        add_project (data) {
            return new Promise((resolve) => {
                this.b$.send('tool', { cmd: "add_project", data }, res => {
                    if (window.performingPlaybackTasks) return resolve()
                    if (res.status && Number(res.status.code) === 0) {
                        resolve (res.data)
                    } else {
                        resolve ()
                    }
                })
            })
        },
        edit_project ({ name, script }) {
            const trigger = '{"key":"value"}'
            const data = {
                name,
                projectId: this.projectId,
                script: window.nuwa.utils.base64.encode(script),
                trigger: window.nuwa.utils.base64.encode(trigger),
            }
            return new Promise((resolve) => {
                this.b$.send('tool', { cmd: 'edit_project', data }, response => {
                    if (window.performingPlaybackTasks) return resolve()
                    if (response.status && Number(response.status.code) === 0) {
                        resolve (response.data)
                    } else {
                        resolve ()
                    }
                })
            })
        },
        async export_execute_file () {
            const ctx = this.b$
            const data = { projectId: this.projectId }
            await ctx.send('tool', { cmd: 'export_execute_file', data }, this.handler)
        },
        handler (letter) {
            if (letter.data.state === "task_finished") {
                this.b$.assignment('tool', { executeUrl: letter.data.url }, 'store')
            }
        },
        
        saveProjectAndExportExecuteUrl (_project, newAndSave, md = 0, cb) {
            return new Promise(async resolve => {
                const xml = window.Blockly.Xml.workspaceToDom(this.workSpace)
                const scriptXml = window.Blockly.Xml.domToText(xml)
                const project = md === 0 ? this.projectData : this.playItem
                const { projectId } = project
                if (newAndSave || !projectId) {
                    cb && cb('add')
                    let projectData = await this.add_project(_project, cb)
                    if (!projectData || window.performingPlaybackTasks) return resolve()
                    projectData = Object.assign(projectData, {
                        name: _project.name || Vue.prototype.$t("code-lab/component/mixins/save-project-mix.js_1"),
                        script: scriptXml,
                        materials: [],
                    })
                    const { name, projectId, script, materials } = projectData
                    if (md === 0) {
                        this.$store.commit("UPDATE_PROJECT_DATA", { name, projectId, script, materials })
                    } else if (md === 1) {
                        this.$store.commit("playItem/updatePlayProject", { name, projectId, script, materials })
                    }
                }
                this.projectId = md === 0 ? this.projectData.projectId : this.playItem.projectId
                cb && cb('edit')
                const resEdit = await this.edit_project({ name: _project.name, script: scriptXml }, cb)
                if (!resEdit || window.performingPlaybackTasks) {
                    return resolve()
                } else {
                    this.$emit("confirm", { name: _project.name })
                    return resolve(resEdit)
                }
            })
        },
    },
}
